<ng-container *ngIf="isLoading">
  <div class="overlay">
    <!-- <div class="loaderScreen">
          <img src="../../../assets/loaderLogo.svg" width="150px" alt="">
      </div>-->

    <body>

      <div id="preloader">
        <div class="loader-wrapper">
          <img src="../../../assets/images/nishwik.png" alt="Logo" class="loader-logo">
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>

    </body>
  </div>
</ng-container>